import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PcsComponentsModule } from '@app/pcs/shared/components/pcs-components.module';
import { DossierSearchGridModule } from '@app/pcs/shared/containers/search-results-grid/dossier-search-grid.module';
import { PcsDirectivesModule } from '@app/pcs/shared/directives/pcs-directives.module';
import { NotificationsDataService } from '@app/pcs/shared/notifications/service/notifications-data-service';
import { TtpSearchModule } from '@app/pcs/shared/ttp-search/ttp-search.module';

@NgModule({
  imports: [
    CommonModule,
    PcsDirectivesModule,
    PcsComponentsModule,
    DossierSearchGridModule,
    TtpSearchModule
  ],
  declarations: [],
  providers: [
    NotificationsDataService
  ],
  exports: [
    CommonModule,
    PcsDirectivesModule,
    PcsComponentsModule,
    DossierSearchGridModule,
    TtpSearchModule
  ]
})
export class PcsSharedModule {
}
